import { getOrgSlugFromJWT } from '@/utilities/stytch/getOrgSlugFromJWT'
import { getStytchJWT } from '@/utilities/stytch/getStytchJWT'
import {
  DEFAULT_PATIENT_PORTAL_ORG_SLUG,
  getLocalhostOrgSlugFromPath,
  getOrgSlugFromHostname,
  isLocalHostname,
  normalizeOrgSlug,
} from '@/utilities/shared/orgSlug'

export function getOrgSlugFromUrl(url?: string): string | null {
  if (!url && typeof window === 'undefined') {
    return null
  }

  try {
    const urlObj = new URL(url || window.location.href)

    const orgSlugFromQuery = normalizeOrgSlug(urlObj.searchParams.get('slug'))
    if (urlObj.pathname.startsWith('/authenticate') && orgSlugFromQuery) {
      return orgSlugFromQuery
    }

    if (isLocalHostname(urlObj.hostname)) {
      const localhostSlug = getLocalhostOrgSlugFromPath(urlObj.pathname)
      if (localhostSlug) {
        return localhostSlug
      }

      const decodedJWT = getStytchJWT()
      return decodedJWT ? getOrgSlugFromJWT(decodedJWT) : null
    }

    return getOrgSlugFromHostname(urlObj.hostname)
  } catch {
    return null
  }
}

export function getOrgSlugOrDefault(
  url?: string,
  fallback: string = DEFAULT_PATIENT_PORTAL_ORG_SLUG,
): string {
  return normalizeOrgSlug(getOrgSlugFromUrl(url)) || fallback
}

export const getOrgFromUrl = getOrgSlugFromUrl
